import Upgrade from './upgrade'
import { UpgradeNames } from '../constants'

export default class CreditsPerPuzzleUpgrade extends Upgrade {
  getName (): string {
    return UpgradeNames.CREDITS_PER_PUZZLE
  }

  buy () {
    super.buy()

    this.credits.perPuzzle += 250
  }

  get current () {
    return this.credits.perPuzzle
  }

  get next () {
    return this.credits.perPuzzle + 250
  }
}
